export default __webpack_public_path__ + "static/media/healthy-care.756116fa.svg";